import React from 'react'

import { FooterLogo } from './components/FooterLogo'
import { FooterInfo } from './components/FooterInfo'
import { FooterAbout } from './components/FooterAbout'
import { FooterContact1 } from './components/FooterContact1'
import { FooterContact2 } from './components/FooterContact2'

const FooterMain: React.FC = () => {
    return (
        <div className="flex flex-col w-full p-5 items-center  text-[#FFFFFF] bg-[#181818]">
            <div className="flex flex-col lg:flex-row xl:max-w-[1260px] w-full h-fit py-5 text-white gap-10">
                <div className="flex flex-col lg:basis-1/5 items-end justify-start gap-10">
                    <FooterLogo />
                </div>
                <div className="flex flex-col lg:basis-1/5 items-start justify-start gap-5">
                    <FooterInfo />
                </div>
                <div className="flex flex-col lg:basis-1/5 items-start justify-start gap-5">
                    <FooterAbout />
                </div>
                <div className="flex flex-col lg:basis-1/5 items-start justify-start gap-5">
                    <FooterContact1 />
                </div>
                <div className="flex flex-col lg:basis-1/5 items-start justify-start gap-5">
                    <FooterContact2 />
                </div>
            </div>

            <div className="flex flex-col xl:max-w-[700px] h-fit pt-5 items-center justify-center gap-3 text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                <div className="text-center">
                    ООО «Технологии Закупок» использует файлы cookie для
                    корректной работы сайта, персонализации пользователей и
                    других целей, предусмотренных{' '}
                    <a
                        className="text-sky-600 hover:text-sky-400"
                        href="#/docs/privacy-policy"
                        target="_blank"
                    >
                        политикой конфиденциальности
                    </a>{' '}
                    <br /> Предложенния, размещенные на сайте, не являются
                    публичной офертой{' '}
                </div>
                <div>© 2021-2025 ООО «Технологии Закупок»</div>
            </div>
        </div>
    )
}

export default FooterMain
